import { render, staticRenderFns } from "./common-loading.vue?vue&type=template&id=c8f4406c&scoped=true&"
import script from "./common-loading.vue?vue&type=script&lang=js&"
export * from "./common-loading.vue?vue&type=script&lang=js&"
import style0 from "./common-loading.vue?vue&type=style&index=0&id=c8f4406c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f4406c",
  null
  
)

export default component.exports